import React, { ReactElement, useEffect } from 'react';
import { Link, LoaderButton } from 'idsk-react-components';
import './terminListActions.scss';
import { useParams } from 'react-router';
import routes from '../../../../../../routing/routes';
import { useClient, useClientStatusContext } from '../../../../../../context/ClientStatusContext';
import {
  terminListErrorStatus,
} from '../../../../../../constants/ErrorConstant';
import downloadFile from '../../../../../../functions/downloadFile';
import { exportTerminListAdmin } from '../../../../../../client/export/exportTerminListClient';
import { TerminListAdminFilter } from '../../../../../../model/TerminListAdminFilter';

export interface Props {
  filter: TerminListAdminFilter;
  isDisabled: boolean;
}

const TerminListActions = ({ filter, isDisabled }: Props): ReactElement => {
  const { tezaurusUuid } = useParams<{ tezaurusUuid: string }>();
  const { handleStatus } = useClientStatusContext();

  const {
    wrapClient: exportTerminAdmin,
    status: exportTerminAdminStatus,
  } = useClient(exportTerminListAdmin);

  useEffect(() => {
    if (exportTerminAdminStatus.responseCode === 404) {
      handleStatus(terminListErrorStatus);
    }
  }, [exportTerminAdminStatus, handleStatus]);

  const onExportToPdf = async (e): Promise<void> => {
    e.preventDefault();
    const { data } = await exportTerminAdmin(
      tezaurusUuid,
      filter.hladanyTermin,
      filter.publikovany,
      filter.autorPoslednejZmeny?.uuid,
    );

    if (data.blob) {
      downloadFile(data.fileName, data.blob);
    }
  };

  return (
    <div className="terminy-list">
      <Link
        to={routes.tezaurus.admin.termin.create.withParams(tezaurusUuid)}
        className="termin-list__add"
        type="button-action"
        size="large"
      >
        Pridať termín
      </Link>
      <LoaderButton
        disabled={isDisabled}
        loading={exportTerminAdminStatus.loading}
        size="large"
        buttonStyle="third"
        type="button"
        onClick={(event) => onExportToPdf(event)}
      >Exportovať termíny (PDF)
      </LoaderButton>
    </div>
  );
};

export default TerminListActions;
